enum Views {
  MAIN,
  MATCHERS,
}

export { Views };
